import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { Button, Typography, Box } from '@mui/material';

import { ACTIONS_PAUSED_MODAL_KEY } from '@/constants/actionsPaused';
import useActionsPaused from '@/hooks/useActionsPaused';
import BaseModal from '@components/molecules/modals/BaseModal';

const ActionsPausedModal = () => {
    const [open, setOpen] = useState(false);
    const userId = useSelector((state) => state.auth.user?.id);
    const actionsPaused = useActionsPaused();

    useEffect(() => {
        if (userId && actionsPaused && !sessionStorage.getItem(ACTIONS_PAUSED_MODAL_KEY)) {
            setOpen(true);
        }
    }, [userId, actionsPaused]);

    const handleClose = () => {
        sessionStorage.setItem(ACTIONS_PAUSED_MODAL_KEY, 'true');
        setOpen(false);
    };

    return (
        <BaseModal
            title="Ações temporariamente pausadas"
            open={open}
            handleClose={handleClose}
            maxWidth="sm"
            centerActions={true}
            withActions={
                <Button onClick={handleClose} variant="contained" color="primary">
                    Entendi
                </Button>
            }
        >
            <Box sx={{ textAlign: 'center', py: 3 }}>
                <Typography variant="h6" gutterBottom sx={{ fontWeight: 500 }}>
                    Estamos migrando seus dados para a nova versão do Rehsult. Até a conclusão, não é possível criar, editar ou excluir
                    informações.
                </Typography>

                <Typography variant="body1" sx={{ mt: 2 }} color="textSecondary">
                    A consulta segue normalmente, e as ações retornarão em breve.
                </Typography>
            </Box>
        </BaseModal>
    );
};

export default ActionsPausedModal;
